import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '@aws-amplify/auth';
import { Lock } from 'lucide-react';
import { Button } from '../tailwind/button';
import { getNoModulesMessage } from '../../utils/capabilitiesHelper';
import { clearStorage } from '../../utils/clearStorageHelper';
import { setGlobalWhatsAppMode } from '../../hooks/useWhatsAppMode';

const NoModulesMessage = () => {
  const navigate = useNavigate();
  const { title, message, contactUrl, buttonText } = getNoModulesMessage();

  const handleLogout = async () => {
    try {
      await signOut();
      setGlobalWhatsAppMode('signIn');
      clearStorage();
      navigate('/');
      window.location.reload();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-50 dark:bg-slate-950 z-50">
      <div className="max-w-md w-full mx-4 p-8 bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="h-16 w-16 bg-yellow-100 dark:bg-yellow-900/20 rounded-full flex items-center justify-center">
            <Lock className="h-8 w-8 text-yellow-600 dark:text-yellow-400" />
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
            {title}
          </h2>
          
          <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
            {message}
          </p>
          
          <Button
            onClick={() => window.open(contactUrl, '_blank')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold mt-4 cursor-pointer"
          >
            {buttonText}
          </Button>

          <Button
            onClick={handleLogout}
            className="w-full bg-gray-800 hover:bg-gray-900 text-white font-semibold mt-2 cursor-pointer"
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoModulesMessage;
